export interface RouteSection {
	base: string
	create: string
	edit: (id: number | string) => string
	show: (id: number | string) => string
}

function getRouteSections(name: string): RouteSection {
	return {
		base: `/${name}`,
		create: `/${name}/create`,
		edit: (id: number | string) => `/${name}/${id}/edit`,
		show: (id: number | string) => `/${name}/${id}`,
	}
}

const salesforceBaseUrl = process.env.NEXT_PUBLIC_SALESFORCE_BASE_URL ?? 'https://resonetics.lightning.force.com'

export const ROUTES = {
	home: '/',
	quotes: getRouteSections('quotes'),
	operations: {
		...getRouteSections('operations'),
		test: (id: number) => `/operations/${id}/test`,
	},
	opportunities: getRouteSections('opportunities'),
	technologies: getRouteSections('technologies'),
	coreSections: getRouteSections('core'),
	login: '/login',
	lookups: getRouteSections('lookups'),
	dataStore: getRouteSections('data-store'),
	quoteTypes: getRouteSections('quote-types'),
	suggestions: getRouteSections('suggestions'),
	migrations: {
		...getRouteSections('migrations'),
		new: '/migrations/new',
	},
	salesforce: {
		base: salesforceBaseUrl,
		entry: (salesForceId: string) => `${salesforceBaseUrl}/${salesForceId}`,
	},
	ppt: {
		base: process.env.NEXT_PUBLIC_PPT_BASE_URL ?? '',
		operations: `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/operations`,
		recipes: `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/recipes`,
		coreSections: `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/core`,
		editTemplate: `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/template/edit`,
		sites: `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/sites`,
		materials: `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/materials`,
		engineers: {
			base: `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/engineers`,
			show: (pptUserId: number | string) => `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/engineers/${pptUserId}`,
		},
		workstations: `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/workstations`,
		jobs: `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/jobs`,
		suggestions: `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/suggestions`,
		sheets: `${process.env.NEXT_PUBLIC_PPT_BASE_URL ?? ''}/sheets`,
	},
} as const
